<template>
    <sidebar @close="$emit('close')">
        <template v-slot:title>
            {{ deductionType.name }}
        </template>

        <template v-slot:header>
            <div>
                <span class="text-semibold">Has been used: </span>
                <span v-if="deductionType.has_been_used">Yes</span>
                <span v-if="!deductionType.has_been_used">No</span>
            </div>
        </template>

        <slot>
            <div class="card mb-2">
                <div class="card-header pr-1 d-flex align-items-center">
                    <span class="btnlike mr-auto">
                        <h4 class="mb-0">Deduction Type</h4>
                    </span>

                    <button class="btn btn-primary" type="button" @click.prevent="editIsOpen = true">Edit</button>
                    <button class="btn btn-outline-primary ml-1" type="button" @click.prevent="onDelete" v-if="!deductionType.has_been_used">Delete</button>
                </div>

                <div class="card-body py-1">
                    <deduction-type-details :deduction-type="deductionType" />
                </div>
            </div>

            <edit-modal
                v-if="editIsOpen"
                :deductionType="deductionType"
                @updated="onUpdate"
                @close="editIsOpen = false"
            />
        </slot>
    </sidebar>
</template>

<script>
import EditModal from './DeductionTypeModal'
import Sidebar from '@/components/Sidebar'
import DeductionTypeDetails from './DeductionTypeVersion'

export default {
    components: {EditModal, Sidebar, DeductionTypeDetails},
    props: ['deductionType', ],
    data() {
        return {
            editIsOpen: false,
        }
    },
    methods: {
        onDelete() {
            if (!confirm("Are you sure?")) {return}

            this.$store.dispatch('START_LOADING')
            this.$api.del(`/admin/tax-engine/deduction-types/${this.deductionType.id}`).then(resp => {
                this.$store.dispatch('STOP_LOADING')
                this.$emit('deleted')
            }).catch(errors => {
                this.$store.dispatch('STOP_LOADING')
                this.$bus.showError(errors.__all__)
            })
        },
        onUpdate($event) {
            this.$emit('updated', $event)
        },
    },
}
</script>
